import cloneDeep from 'lodash/fp/cloneDeep'
import { events } from './adviserProfileClientTypesEditorActions'

import { validiateChecklistField } from '../../../common/forms/validationFunctions'

const initialState = {
  submitting: false,
  loadingClientTypes: false,
  editingClientTypes: false,
  clientTypesBeforeEditing: [],
  allClientTypes: [],
  isInvalid: {
    formIsValid: true,
    clientTypes: {
      isInvalid: false,
      message: null
    }
  }
}

const minimumRequiredSelection = 1

export default function (state = initialState, action) {
  var newState = copyClientTypePreferencesState(state)
  const { edit, set, fetch } = events

  switch (action.type) {
    case edit.start:
      newState.clientTypes.editingClientTypes = true
      newState.clientTypesBeforeEditing = newState.profile.clientTypePreferences
      newState.clientTypes.isInvalid.clientTypes = validiateChecklistField(newState.profile.clientTypePreferences, minimumRequiredSelection)
      newState.clientTypes.isInvalid.formIsValid = formIsValid(newState.clientTypes.isInvalid)
      return newState
    case edit.stop:
      newState.clientTypes.editingClientTypes = false
      return newState
    case edit.cancel:
      newState.clientTypes.editingClientTypes = false
      newState.profile.clientTypePreferences = cloneDeep(newState.clientTypesBeforeEditing)
      newState.clientTypesBeforeEditing = []
      return newState
    case fetch.fetched:
      newState.clientTypes.allClientTypes = action.payload
      return newState
    case set.selectionChanged:
      var foundIndex = null
      var selectedClientTypes = newState.profile.clientTypePreferences
      selectedClientTypes.forEach((clientType, index) => {
        if (clientType.clientTypeId === action.clientType.clientTypeId) {
          foundIndex = index
        }
      })
      if (foundIndex !== null) {
        selectedClientTypes.splice(foundIndex, 1)
      } else {
        selectedClientTypes.push(action.clientType)
      }
      newState.clientTypes.isInvalid.clientTypes = validiateChecklistField(selectedClientTypes, minimumRequiredSelection)
      newState.clientTypes.isInvalid.formIsValid = formIsValid(newState.clientTypes.isInvalid)
      newState.edited = true
      return newState
  }
  return state
}

function copyClientTypePreferencesState (state) {
  var newState = cloneDeep(state)
  newState.profile = cloneDeep(state.profile)
  if (state.profile) {
    newState.profile.clientTypePreferences = cloneDeep(state.profile.clientTypePreferences)
  }
  return newState
}

function formIsValid (isInvalid) {
  return !isInvalid.clientTypes.isInvalid
}
